var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnualReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 620,
    viewBox: "0 0 631 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.335 457.553C324.713 457.553 249.873 457.553 177.291 457.553C167.668 457.553 159.947 449.625 160.184 440.04C162.679 349.633 161.966 241.832 159.947 126.102C159.828 116.635 167.431 108.707 177.053 108.707C252.249 110.718 326.852 110.718 401.098 108.707C410.364 108.707 417.966 116.162 418.204 125.392C420.58 241.713 421.293 349.87 418.442 440.987C418.085 450.335 410.601 457.553 401.335 457.553Z",
    fill: "#1E4387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.259 131.663C191.545 236.507 176.695 433.413 176.695 433.413C176.695 433.413 306.774 436.608 353.698 433.413C384.346 413.652 402.047 383.003 402.047 383.003C407.868 274.61 396.226 131.545 396.226 131.545C260.564 134.74 180.259 131.663 180.259 131.663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.058 170.95H201.883V189.055H220.058V170.95Z",
    fill: "#0BAFD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.225 186.215H226.947C225.403 186.215 225.403 188.582 226.947 188.582H286.225C287.77 188.582 287.77 186.215 286.225 186.215Z",
    fill: "#191B1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.225 178.76H226.947C225.403 178.76 225.403 181.127 226.947 181.127H286.225C287.77 181.245 287.77 178.76 286.225 178.76Z",
    fill: "#191B1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M286.222 171.423H249.158C247.614 171.423 247.614 173.79 249.158 173.79H286.222C287.766 173.79 287.766 171.423 286.222 171.423Z",
    fill: "#191B1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.058 214.142H201.883V232.247H220.058V214.142Z",
    fill: "#0BAFD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.225 229.407H226.947C225.403 229.407 225.403 231.773 226.947 231.773H286.225C287.77 231.773 287.77 229.407 286.225 229.407Z",
    fill: "#191B1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.225 222.07H226.947C225.403 222.07 225.403 224.437 226.947 224.437H286.225C287.77 224.437 287.77 222.07 286.225 222.07Z",
    fill: "#191B1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M286.222 214.615H249.158C247.614 214.615 247.614 216.982 249.158 216.982H286.222C287.766 217.1 287.766 214.615 286.222 214.615Z",
    fill: "#191B1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.636 170.95H298.461V189.055H316.636V170.95Z",
    fill: "#0BAFD4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M382.803 186.215H323.525C321.981 186.215 321.981 188.582 323.525 188.582H382.803C384.348 188.582 384.348 186.215 382.803 186.215Z",
    fill: "#191B1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M382.803 178.76H323.525C321.981 178.76 321.981 181.127 323.525 181.127H382.803C384.348 181.245 384.348 178.76 382.803 178.76Z",
    fill: "#191B1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382.8 171.423H345.736C344.192 171.423 344.192 173.79 345.736 173.79H382.8C384.344 173.79 384.344 171.423 382.8 171.423Z",
    fill: "#191B1C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M316.636 214.142H298.461V232.247H316.636V214.142Z",
    fill: "#0BAFD4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M382.803 229.407H323.525C321.981 229.407 321.981 231.773 323.525 231.773H382.803C384.348 231.773 384.348 229.407 382.803 229.407Z",
    fill: "#191B1C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M382.803 222.07H323.525C321.981 222.07 321.981 224.437 323.525 224.437H382.803C384.348 224.437 384.348 222.07 382.803 222.07Z",
    fill: "#191B1C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M382.8 214.615H345.736C344.192 214.615 344.192 216.982 345.736 216.982H382.8C384.344 217.1 384.344 214.615 382.8 214.615Z",
    fill: "#191B1C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M234.196 262.658C221.366 262.658 211.031 272.953 211.031 285.733H234.196V262.658Z",
    fill: "#1E4387"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.196 262.658V285.733H211.031C211.031 298.513 221.366 308.808 234.196 308.808C247.026 308.808 257.361 298.513 257.361 285.733C257.48 273.072 247.026 262.658 234.196 262.658Z",
    fill: "#0BAFD4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M297.276 262.658V285.733L277.318 273.782C275.18 277.213 273.992 281.355 273.992 285.733C273.992 298.513 284.327 308.808 297.157 308.808C309.987 308.808 320.322 298.513 320.322 285.733C320.559 273.072 310.105 262.658 297.276 262.658Z",
    fill: "#0BAFD4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M297.278 262.658C288.843 262.658 281.478 267.155 277.32 273.9L297.278 285.852V262.658Z",
    fill: "#1E4387"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M360.352 262.658C347.523 262.658 337.188 272.953 337.188 285.733C337.188 290.112 338.375 294.253 340.514 297.685L360.352 285.733V262.658Z",
    fill: "#1E4387"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M360.354 262.658V285.733L340.516 297.803C344.555 304.43 351.92 308.927 360.354 308.927C373.184 308.927 383.519 298.632 383.519 285.852C383.638 273.072 373.184 262.658 360.354 262.658Z",
    fill: "#0BAFD4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.348 329.872H227.299C225.755 329.872 225.755 332.238 227.299 332.238H360.348C361.892 332.238 361.892 329.872 360.348 329.872Z",
    fill: "#191B1C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M379.121 344.072H208.533C206.989 344.072 206.989 346.438 208.533 346.438H379.121C380.665 346.557 380.665 344.072 379.121 344.072Z",
    fill: "#191B1C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M379.121 358.39H208.533C206.989 358.39 206.989 360.757 208.533 360.757H379.121C380.665 360.757 380.665 358.39 379.121 358.39Z",
    fill: "#191B1C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M379.121 372.59H208.533C206.989 372.59 206.989 374.957 208.533 374.957H379.121C380.665 375.075 380.665 372.59 379.121 372.59Z",
    fill: "#191B1C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M401.931 383.003C371.52 400.043 342.297 402.765 342.297 402.765C356.79 418.977 353.582 433.295 353.582 433.295C353.582 433.295 379.36 417.793 401.931 383.003Z",
    fill: "#D8D8D8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M347.877 150.833H232.291C227.776 150.833 224.094 147.165 224.094 142.668V125.155C224.094 120.658 227.776 116.99 232.291 116.99H347.877C352.391 116.99 356.073 120.658 356.073 125.155V142.668C356.073 147.165 352.391 150.833 347.877 150.833ZM232.291 120.422C229.677 120.422 227.539 122.552 227.539 125.155V142.668C227.539 145.272 229.677 147.402 232.291 147.402H347.877C350.49 147.402 352.628 145.272 352.628 142.668V125.155C352.628 122.552 350.49 120.422 347.877 120.422H232.291Z",
    fill: "#85586F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M338.377 103.618H241.679C237.878 103.618 234.789 106.695 234.789 110.482V130.717C234.789 134.503 237.878 137.58 241.679 137.58H338.377C342.178 137.58 345.267 134.503 345.267 130.717V110.482C345.267 106.695 342.178 103.618 338.377 103.618Z",
    fill: "#1E4387"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M243.578 111.547H292.996",
    stroke: "#FFFAD7",
    strokeWidth: 1.3623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M297.273 111.547H306.064",
    stroke: "#FFFAD7",
    strokeWidth: 1.3623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M265.281 323.607L260.008 327.034L274.418 349.035L279.691 345.608L265.281 323.607Z",
    fill: "#2B2722"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M277.673 256.032C260.21 232.01 231.106 224.555 207.585 241.359C184.895 257.57 178.005 285.142 192.854 311.175C206.634 335.434 237.758 343.717 262.942 325.849C285.632 309.637 293.948 278.634 277.673 256.032ZM257.003 316.737C237.283 330.819 212.812 324.192 202.001 305.259C190.36 284.787 195.705 263.132 213.524 250.47C231.937 237.217 254.865 243.134 268.526 261.949C281.356 279.699 274.822 304.075 257.003 316.737Z",
    fill: "#1E4387"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M313.075 394.009L305.353 398.979C303.809 400.044 301.552 399.57 300.602 398.032L271.022 352.947C269.953 351.409 270.428 349.16 271.972 348.214L279.694 343.244C281.238 342.179 283.495 342.652 284.446 344.19L314.025 389.275C315.094 390.814 314.619 392.944 313.075 394.009Z",
    fill: "#0BAFD4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M498.866 233.548C469.999 232.365 438.875 232.602 406.326 233.548C400.386 233.548 395.516 228.697 395.516 222.78C397.416 177.34 397.298 129.297 395.516 78.7683C395.516 72.8517 400.386 68 406.326 68C436.737 68.5917 467.505 68.5917 498.866 68C504.806 68 509.676 72.8517 509.676 78.7683C507.776 125.155 507.894 173.198 509.676 222.78C509.557 228.697 504.806 233.548 498.866 233.548Z",
    fill: "#0BAFD4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M481.761 90.4834C474.395 83.1467 464.179 78.6501 452.656 79.1234V120.303L481.761 90.4834Z",
    fill: "#2A57A0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M492.097 108.115C490.078 101.37 486.514 95.3351 481.643 90.4834L452.539 120.303L492.097 108.115Z",
    fill: "#3C71C6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M452.54 79.2417C429.731 80.1884 412.506 97.5834 411.199 120.422C410.012 143.142 429.731 161.602 452.54 161.602C462.756 161.602 472.141 157.933 479.387 151.78L452.54 120.303V79.2417Z",
    fill: "#1E4387"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M493.879 120.303C493.879 116.043 493.285 112.02 492.097 108.115L452.539 120.303L479.386 151.662C488.296 144.088 493.879 132.847 493.879 120.303Z",
    fill: "#5D92E8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M424.622 187.99H418.682C417.375 187.99 416.188 186.925 416.188 185.505V179.588C416.188 178.287 417.257 177.103 418.682 177.103H424.622C425.929 177.103 427.117 178.168 427.117 179.588V185.505C427.117 186.925 426.047 187.99 424.622 187.99Z",
    fill: "#1E4387"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M487.348 177.222H447.433C445.533 177.222 445.533 180.18 447.433 180.18H487.348C489.249 180.298 489.249 177.222 487.348 177.222Z",
    fill: "#1E4387"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M487.346 183.848H434.84C432.939 183.848 432.939 186.807 434.84 186.807H487.346C489.247 186.807 489.247 183.848 487.346 183.848Z",
    fill: "#1E4387"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M487.346 190.475H434.84C432.939 190.475 432.939 193.433 434.84 193.433H487.346C489.247 193.433 489.247 190.475 487.346 190.475Z",
    fill: "#1E4387"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M424.622 212.485H418.682C417.375 212.485 416.188 211.42 416.188 210V204.083C416.188 202.782 417.257 201.599 418.682 201.599H424.622C425.929 201.599 427.117 202.663 427.117 204.083V210C427.117 211.42 426.047 212.485 424.622 212.485Z",
    fill: "#1E4387"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M487.348 201.717H447.433C445.533 201.717 445.533 204.675 447.433 204.675H487.348C489.249 204.793 489.249 201.717 487.348 201.717Z",
    fill: "#1E4387"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M487.346 208.343H434.84C432.939 208.343 432.939 211.302 434.84 211.302H487.346C489.247 211.302 489.247 208.343 487.346 208.343Z",
    fill: "#1E4387"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M487.346 214.97H434.84C432.939 214.97 432.939 217.928 434.84 217.928H487.346C489.247 217.928 489.247 214.97 487.346 214.97Z",
    fill: "#1E4387"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M109.221 316.5C74.7708 315.553 40.4395 315.553 6.5833 316.5C3.49466 316.5 1 314.015 1 310.938C1.59397 292.36 1.71276 273.9 1 255.322C1 252.245 3.49466 249.76 6.5833 249.76C39.3703 250.352 73.7017 250.352 109.221 249.76C112.31 249.76 114.804 252.245 114.804 255.322C114.21 274.492 114.21 293.07 114.804 310.938C114.804 314.015 112.31 316.5 109.221 316.5Z",
    fill: "#1E4387"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M55.051 258.635H43.7656V307.507H55.051V258.635Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M71.676 279.935H60.3906V307.507H71.676V279.935Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.426 290.94H77.1406V307.507H88.426V290.94Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M105.059 267.628H93.7734V307.507H105.059V267.628Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7338 304.904H12.0442C10.3811 304.904 10.3811 307.507 12.0442 307.507H34.7338C36.5157 307.507 36.5157 304.904 34.7338 304.904Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7338 298.632H12.0442C10.3811 298.632 10.3811 301.235 12.0442 301.235H34.7338C36.5157 301.235 36.5157 298.632 34.7338 298.632Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0442 294.963H34.7338C36.3969 294.963 36.3969 292.36 34.7338 292.36H12.0442C10.3811 292.36 10.3811 294.963 12.0442 294.963Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0442 288.692H27.2498C28.9129 288.692 28.9129 286.088 27.2498 286.088H12.0442C10.3811 286.088 10.3811 288.692 12.0442 288.692Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M254.86 425.485C205.442 423.947 156.024 423.947 106.606 425.485C100.31 425.485 95.3203 420.397 95.3203 414.243C96.8646 394.127 96.8646 373.3 95.3203 351.882C95.3203 345.61 100.428 340.64 106.606 340.64C155.073 341.587 204.492 341.587 254.86 340.64C261.156 340.64 266.145 345.728 266.145 351.882C264.601 373.3 264.482 394.127 266.145 414.243C266.264 420.397 261.156 425.485 254.86 425.485Z",
    fill: "#0BAFD4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M153.647 382.057C153.766 382.767 153.884 383.595 153.884 384.423C153.884 390.813 148.658 396.02 142.243 396.02C135.828 396.02 130.601 390.813 130.601 384.423C130.601 378.033 135.828 372.827 142.243 372.827V353.302C125.018 353.302 111 367.265 111 384.423C111 401.582 125.018 415.545 142.243 415.545C159.468 415.545 173.485 401.582 173.485 384.423C173.485 382.293 173.248 380.163 172.891 378.033L153.647 382.057Z",
    fill: "#304882"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M146.281 368.685C151.865 368.685 156.616 372.708 157.685 377.915L176.811 373.892C173.841 359.692 161.249 349.16 146.281 349.16V368.685Z",
    fill: "#304882"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M253.317 405.96H186.436C184.417 405.96 184.417 409.155 186.436 409.155H253.317C255.456 409.155 255.456 405.96 253.317 405.96Z",
    fill: "#304882"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M253.317 393.417H186.436C184.417 393.417 184.417 396.612 186.436 396.612H253.317C255.456 396.612 255.456 393.417 253.317 393.417Z",
    fill: "#304882"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M253.317 380.755H186.436C184.417 380.755 184.417 383.95 186.436 383.95H253.317C255.456 383.95 255.456 380.755 253.317 380.755Z",
    fill: "#304882"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M253.317 368.212H186.436C184.417 368.212 184.417 371.407 186.436 371.407H253.317C255.456 371.407 255.456 368.212 253.317 368.212Z",
    fill: "#304882"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M253.316 355.668H215.421C213.401 355.668 213.401 358.863 215.421 358.863H253.316C255.454 358.863 255.454 355.668 253.316 355.668Z",
    fill: "#304882"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M582.022 343.244C533.911 342.652 489.363 342.415 456.22 343.244C452.062 343.244 448.617 339.812 448.617 335.67C449.568 315.198 449.449 293.307 448.617 270.587C448.617 266.445 452.062 263.013 456.22 263.013C504.569 263.487 550.067 263.723 582.022 263.013C586.18 263.013 589.625 266.445 589.625 270.587C588.794 291.887 588.794 313.66 589.625 335.67C589.625 339.812 586.18 343.244 582.022 343.244Z",
    fill: "#1E4387"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M472.141 273.308H459.43V331.41H472.141V273.308Z",
    fill: "#FCFCFC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M490.195 299.697H477.484V331.292H490.195V299.697Z",
    fill: "#FCFCFC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M508.375 285.023H495.664V331.41H508.375V285.023Z",
    fill: "#FCFCFC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M526.43 314.489H513.719V331.41H526.43V314.489Z",
    fill: "#FCFCFC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M579.416 274.255H549.599C548.53 274.255 548.53 275.794 549.599 275.794H579.416C580.485 275.794 580.485 274.255 579.416 274.255Z",
    fill: "#FCFCFC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M579.413 285.26H537.122C536.053 285.26 536.053 286.799 537.122 286.799H579.413C580.482 286.68 580.482 285.26 579.413 285.26Z",
    fill: "#FCFCFC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M579.413 296.147H537.122C536.053 296.147 536.053 297.685 537.122 297.685H579.413C580.482 297.685 580.482 296.147 579.413 296.147Z",
    fill: "#FCFCFC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M579.413 307.152H537.122C536.053 307.152 536.053 308.69 537.122 308.69H579.413C580.482 308.69 580.482 307.152 579.413 307.152Z",
    fill: "#FCFCFC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M579.413 318.039H537.122C536.053 318.039 536.053 319.577 537.122 319.577H579.413C580.482 319.577 580.482 318.039 579.413 318.039Z",
    fill: "#FCFCFC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M579.413 329.043H537.122C536.053 329.043 536.053 330.582 537.122 330.582H579.413C580.482 330.582 580.482 329.043 579.413 329.043Z",
    fill: "#FCFCFC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M236.233 118.271C236.233 122.677 236.017 126.975 235.478 131.273C234.508 140.3 232.46 149.004 229.549 157.278C226.315 166.52 221.895 175.331 216.396 183.283C214.456 186.184 212.3 189.086 210.036 191.88C204.861 198.327 198.932 204.13 192.464 209.395C189.661 211.652 186.858 213.694 183.839 215.735C175.754 221.108 167.021 225.514 157.75 228.845C149.449 231.746 140.717 233.788 131.661 234.755C127.349 235.185 123.036 235.508 118.616 235.508C114.196 235.508 109.884 235.293 105.572 234.755C96.5161 233.788 87.7839 231.746 79.4828 228.845C70.2115 225.621 61.3714 221.216 53.3937 215.735C50.483 213.801 47.5722 211.652 44.7693 209.395C38.3009 204.237 32.4794 198.327 27.1969 191.88C24.9329 189.086 22.8846 186.292 20.8363 183.283C15.446 175.224 11.026 166.52 7.68397 157.278C4.77321 149.004 2.72489 140.3 1.75464 131.273C1.32341 126.975 1 122.677 1 118.271C1 113.865 1.21561 109.567 1.75464 105.268C2.72489 96.242 4.77321 87.5379 7.68397 79.2637C10.9182 70.0223 15.446 61.2107 20.8363 53.2588C22.7768 50.3575 24.9329 47.4561 27.1969 44.6622C32.3716 38.2147 38.3009 32.412 44.7693 27.1466C47.5722 24.89 50.3752 22.8483 53.3937 20.8066C61.4792 15.4337 70.2115 11.0279 79.4828 7.69669C87.7839 4.79533 96.5161 2.75363 105.572 1.7865C109.884 1.35667 114.196 1.0343 118.616 1.0343C123.036 1.0343 127.349 1.24921 131.661 1.7865C140.717 2.75363 149.449 4.79533 157.75 7.69669C167.021 10.9204 175.861 15.3262 183.839 20.8066C186.75 22.7408 189.661 24.89 192.464 27.1466C198.932 32.3046 204.753 38.2147 210.036 44.6622C212.3 47.4561 214.348 50.25 216.396 53.2588C221.787 61.3182 226.207 70.0223 229.549 79.2637C232.46 87.5379 234.508 96.242 235.478 105.268C235.909 109.459 236.233 113.865 236.233 118.271Z",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M192.458 209.395H183.942H157.745H131.656H105.459H79.3698H53.1729H44.6562",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7344 183.39H27.0949H53.184H79.3809H105.47H131.667H157.756H183.953H210.042H216.402",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M229.444 157.278H210.039H183.95H157.753H131.664H105.468H79.3785H53.1816H27.0926H7.6875",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M235.48 131.273H210.037H183.948H157.752H131.663H105.466H79.3766H53.1797H27.0907H1.64844",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 105.161H27.0907H53.1797H79.3766H105.466H131.663H157.752H183.948H210.037H235.48",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M229.444 79.1559H210.039H183.95H157.753H131.664H105.468H79.3785H53.1816H27.0926H7.6875",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M216.402 53.1511H210.042H183.953H157.756H131.667H105.47H79.3809H53.184H27.0949H20.7344",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6562 27.0388H53.1729H79.3698H105.459H131.656H157.745H183.942H192.458",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M210.031 191.879V183.39V157.278V131.273V105.161V79.1559V53.1511V44.5544",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M183.945 20.6987V27.0387V53.151V79.1558V105.161V131.273V157.278V183.39V209.395V215.735",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M157.75 228.737V209.395V183.39V157.278V131.273V105.161V79.1558V53.151V27.0387V7.69629",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M131.656 234.755V209.395V183.39V157.278V131.273V105.161V79.1559V53.1511V27.0388V1.67871",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M105.469 1.67871V27.0388V53.1511V79.1559V105.161V131.273V157.278V183.39V209.395V234.755",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.375 7.69629V27.0387V53.151V79.1558V105.161V131.273V157.278V183.39V209.395V228.737",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1797 20.6987V27.0387V53.151V79.1558V105.161V131.273V157.278V183.39V209.395V215.735",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0938 191.879V183.39V157.278V131.273V105.161V79.1559V53.1511V44.5544",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.688785,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M630.536 491.123C630.536 495.957 630.226 500.688 629.71 505.317C628.575 515.192 626.408 524.655 623.209 533.706C619.597 543.786 614.85 553.352 608.865 562.095C606.698 565.284 604.428 568.473 601.951 571.455C596.276 578.45 589.878 584.827 582.861 590.484C579.868 592.953 576.772 595.216 573.47 597.376C564.699 603.239 555.102 608.073 544.989 611.673C535.908 614.862 526.415 617.125 516.508 618.153C511.865 618.668 507.118 618.976 502.268 618.976C497.418 618.976 492.671 618.668 488.027 618.153C478.121 617.022 468.627 614.862 459.546 611.673C449.433 608.073 439.837 603.342 431.065 597.376C427.866 595.216 424.667 592.953 421.675 590.484C414.658 584.827 408.26 578.45 402.584 571.455C400.108 568.473 397.837 565.387 395.67 562.095C389.788 553.352 384.938 543.786 381.327 533.706C378.128 524.655 375.857 515.192 374.826 505.317C374.31 500.688 374 495.957 374 491.123C374 486.288 374.31 481.557 374.826 476.928C375.961 467.054 378.128 457.591 381.327 448.539C384.938 438.459 389.788 428.893 395.67 420.15C397.837 416.961 400.108 413.773 402.584 410.79C408.26 403.795 414.658 397.418 421.675 391.761C424.667 389.292 427.763 387.029 431.065 384.869C439.837 379.006 449.433 374.172 459.546 370.572C468.627 367.383 478.121 365.12 488.027 364.092C492.671 363.577 497.418 363.269 502.268 363.269C507.118 363.269 511.865 363.577 516.508 364.092C526.415 365.223 535.908 367.383 544.989 370.572C555.102 374.172 564.699 378.903 573.47 384.869C576.669 387.029 579.868 389.292 582.861 391.761C589.878 397.418 596.276 403.795 601.951 410.79C604.428 413.773 606.698 416.858 608.865 420.15C614.747 428.893 619.597 438.459 623.209 448.539C626.408 457.591 628.678 467.054 629.71 476.928C630.226 481.557 630.536 486.288 630.536 491.123Z",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M582.858 590.484H573.468H544.987H516.506H488.024H459.543H430.959H421.672",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M395.562 562.095H402.476H430.957H459.542H488.023H516.504H544.985H573.466H602.05H608.861",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M623.211 533.706H602.056H573.472H544.991H516.51H488.029H459.548H430.964H402.483H381.328",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M629.713 505.317H602.057H573.473H544.992H516.511H488.03H459.549H430.965H402.484H374.828",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M374.828 476.928H402.484H430.965H459.549H488.03H516.511H544.992H573.473H602.057H629.713",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M623.211 448.436H602.056H573.472H544.991H516.51H488.029H459.548H430.964H402.483H381.328",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M608.861 420.047H602.05H573.466H544.985H516.504H488.023H459.542H430.957H402.476H395.562",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M421.672 391.658H430.959H459.543H488.024H516.506H544.987H573.468H582.858",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M602.055 571.455V562.095V533.706V505.317V476.928V448.436V420.047V410.687",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M573.469 384.766V391.658V420.047V448.436V476.928V505.317V533.706V562.095V590.484V597.376",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M544.984 611.673V590.484V562.095V533.706V505.317V476.928V448.436V420.047V391.658V370.572",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M516.508 618.153V590.484V562.095V533.706V505.317V476.928V448.436V420.047V391.658V364.092",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M488.023 364.092V391.658V420.047V448.436V476.928V505.317V533.706V562.095V590.484V618.153",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M459.547 370.572V391.658V420.047V448.436V476.928V505.317V533.706V562.095V590.484V611.673",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M430.961 384.766V391.658V420.047V448.436V476.928V505.317V533.706V562.095V590.484V597.376",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M402.484 571.455V562.095V533.706V505.317V476.928V448.436V420.047V410.687",
    stroke: "#1E4387",
    strokeOpacity: 0.13,
    strokeWidth: 0.719749,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnualReport);
export default __webpack_public_path__ + "static/media/anual-report.3e3abc544e5903ed2c9d2a496935746a.svg";
export { ForwardRef as ReactComponent };